import { useState, useEffect, useRef } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContract';

// Checks whether the connected account is the contract owner or admin.
// Exposes hasLoaded so pages can wait for the check BEFORE deciding to redirect.
export const useAdmin = () => {
  const { account } = useWallet();
  const { logic } = useContracts();

  const [ownerAddr, setOwnerAddr] = useState(null);
  const [adminAddr, setAdminAddr] = useState(null);
  const [loading, setLoading] = useState(true); // start true so redirects wait
  const [hasLoaded, setHasLoaded] = useState(false);
  const runIdRef = useRef(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!logic) return;
      const myRun = ++runIdRef.current;
      setLoading(true);
      try {
        const [o, a] = await Promise.all([logic.owner(), logic.admin()]);
        if (cancelled || myRun !== runIdRef.current) return;
        setOwnerAddr(o);
        setAdminAddr(a);
      } catch (_) { /* ignore */ }
      finally {
        if (myRun === runIdRef.current) {
          setLoading(false);
          setHasLoaded(true);
        }
      }
    };
    load();
    return () => { cancelled = true; };
  }, [logic]);

  const norm = (a) => {
    try { return a ? ethers.utils.getAddress(a) : null; } catch { return null; }
  };
  const acc = norm(account);
  const isOwner = !!(acc && ownerAddr && acc === norm(ownerAddr));
  const isAdmin = !!(acc && adminAddr && acc === norm(adminAddr));

  return {
    isOwner,
    isAdmin,
    isElevated: isOwner || isAdmin,
    ownerAddr,
    adminAddr,
    loading,
    hasLoaded
  };
};
